<ppb-start-container>
  <form [formGroup]="loginForm">
    <div>
      <div>
        <h3 class="login-title"
            i18n="@@account.activate_account">Aktywuj konto</h3>
        <div *ngIf="isLinkCheckLoading"
             i18n="@@account.validate_link">
          Walidacja linku
        </div>
        <div *ngIf="!isLinkCheckLoading && !isLinkValid"
             i18n="@@account.link_expired"
        >
          Link utracił ważność
          <div fxLayout="row"
               fxLayoutAlign="center">
            <button
              class="o-btn o-btn--small o-btn--primary"
              [type]="ButtonType.SUBMIT"
              (click)="navigateToHome()"
            >Powrót do strony głównej
            </button>
          </div>
        </div>
        <div *ngIf="!isLinkCheckLoading && isLinkValid">
          <div *ngIf="step === 1">
            <div *ngIf="isError()"
                 class="error-message">
              {{errorMessage()}}
            </div>
            <div class="standard-message"
                 i18n="@@account.standard_message">
              Dziękujemy za rejestrację w Portalu Partnera Biznesowego. W celu aktywacji konta
              kliknij na poniższy przycisk.
              Na numer telefonu podany przy rejestracji przesłany zostanie sms umożliwiający
              potwierdzenie numeru telefonu i aktywację konta.
            </div>
            <div *ngIf="!rulesAlreadyAccepted" class="o-form-check__custom">
              <pseic-form-checkbox
                controlName="rulesAgreementControl"
                [formGroup]="loginForm"
                [resizeOnError]="false"
              >
                <span i18n="@@account.rules_agreement">Oświadczam, że zapoznałem się z treścią <a
                  href="{{configuration.agreements.rulesUrl}}" target="_blank">
          Regulaminu Portalu Partnera Biznesowego</a> i&nbsp;akceptuję jego postanowienia.</span>
              </pseic-form-checkbox>
            </div>
            <div *ngIf="!policiesAlreadyAccepted" class="o-form-check__custom">
              <pseic-form-checkbox
                controlName="policiesAgreementControl"
                [formGroup]="loginForm"
                [resizeOnError]="false"
              ><span i18n="@@account.policies_agreement">Oświadczam, że zapoznałem się i akceptuję <a
                href="{{configuration.agreements.policiesUrl}}" target="_blank">Politykę prywatności</a>.</span>
              </pseic-form-checkbox>
            </div>
            <div fxLayout="row"
                 fxLayoutAlign="space-between stretch">
              <div></div>
              <div>
                <pseic-async-button
                  [isLoading$]="isLoading$"
                  [type]="ButtonType.SUBMIT"
                  (buttonClicked)="nextStep(2)"
                  i18n="@@account.activate_account"
                >Aktywuj konto
                </pseic-async-button>
              </div>
            </div>
          </div>
          <div *ngIf="step === 2">
            <div *ngIf="isError()"
                 class="error-message">
              {{errorMessage()}}
            </div>
            <div class="o-form-group">
              <pseic-form-field label="Podaj kod sms"
                                labelFor="sms"
                                i18n-label="@@common.enter_sms_code">
                <input class="o-form-field"
                       placeholder="Twój kod sms"
                       id="sms"
                       type="number"
                       autofocus
                       formControlName="sms"
                       i18n-placeholder="@@account.your_sms_code">
              </pseic-form-field>
            </div>
            <div fxLayout="row"
                 fxLayoutAlign="space-between stretch">
              <div></div>
              <div>
                <pseic-async-button
                  [isLoading$]="isLoading$"
                  [type]="ButtonType.SUBMIT"
                  (buttonClicked)="nextStep(3)"
                  i18n="@@common.next"
                >Dalej
                </pseic-async-button>
              </div>
            </div>
          </div>
          <div *ngIf="step === 3">
            <div *ngIf="isError()"
                 class="error-message">
              {{errorMessage()}}
            </div>
            <div class="confirm-message"
                 i18n="@@account.account_activated">
              Konto aktywowane
            </div>
            <div fxLayout="row"
                 fxLayoutAlign="space-between stretch">
              <div></div>
              <div>
                <button class="o-btn o-btn--primary o-btn--small"
                        routerLink="/password-reset"
                        i18n="@@account.set_password">Ustaw hasło
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ppb-start-container>
